<template>
    <div>

      <section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-cyan" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Data Sekolah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th style="width: 5%">No.</th>
                            <th style="width: 20%">Nama Sekolah</th>
                            <th style="width: 20%">Kabupaten</th>
                            <th style="width: 40%">Alamat</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                            <td>{{index+1}}.</td>
                            <td>{{data.type}} {{data.status}} {{data.sekolah}} </td>
                            <td>Kab. {{data.detilkecamatan.detilkabupaten.kabupaten}}</td>
                            <td>{{data.alamat}}</td>
                            <td class="text-center" >
                              <button @click="getView(data.detilkecamatan.id, data.detilkecamatan.kecamatan, data.type, data.status, data.sekolah, data.alamat, data.id)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                  <i class="material-icons" >create</i>
                              </button>
                              <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                  <i class="material-icons" >clear</i>
                              </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>

                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                                <div class="modal-body">


                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Nama Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <input type="text" id="kecamatan" class="form-control" >
                                          <input type="text" id="kecamatan_id" class="form-control" style="display:none" >
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Type Sekolah</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <select class="form-control" v-model="type">
                                              <option>SMA</option>
                                              <option>SMK</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Status</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <select class="form-control" v-model="status">
                                              <option>Negeri</option>
                                              <option>Swasta</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nama Sekolah</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="sekolah" type="text" id="sekolah" class="form-control" placeholder="Ex : 01 Konawe Selatan">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Alamat Sekolah</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="alamat" type="text" id="alamat" class="form-control" placeholder="Ex : Jl. A. YANI No.31">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Nama Kecamatan</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <input v-model="kecamatan" type="text" id="e_kecamatan" class="form-control" >
                                          <input v-model="kecamatan_id" type="text" id="e_kecamatan_id" class="form-control" style="display:none" >
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Type Sekolah</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <select class="form-control" v-model="type">
                                              <option>SMA</option>
                                              <option>SMK</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Status</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <select class="form-control" v-model="status">
                                              <option>Negeri</option>
                                              <option>Swasta</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Nama Sekolah</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="sekolah" type="text" id="sekolah" class="form-control" placeholder="Ex : 01 Konawe Selatan">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="row clearfix">
                                      <div class="col-md-2 form-control-label">
                                          <label for="kode">Alamat Sekolah</label>
                                      </div>
                                      <div class="col-md-10">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input v-model="alamat" type="text" id="alamat" class="form-control" placeholder="Ex : Jl. A. YANI No.31">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



                <!-- ============================================================ MODAL ======================================================================== -->



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>




        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/sekolah/';


export default {
  name: "monev_sekolah",
  data() {
    return {
      kecamatan_id: "",
      kecamatan: "",
      type: "",
      status: "",
      sekolah: "",
      alamat: "",
      id: "",

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: ""


    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          console.log(this.list_data);
        })
    },

    addData : function(){
      fetch(ADD_URL+'add', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          kecamatan : document.getElementById('kecamatan_id').value,
          type : this.type,
          status: this.status,
          sekolah : this.sekolah,
          alamat : this.alamat

        })
      }).then((res_data)=>{
        this.alertku("success", "sukses menambah data");
        this.getData();
      });
    },

    editData : function(){
      fetch(ADD_URL+'update', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token
        },
        body : JSON.stringify({
          kecamatan : document.getElementById('e_kecamatan_id').value,
          type : this.type,
          status: this.status,
          sekolah : this.sekolah,
          alamat : this.alamat,
          id : this.id
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses mengubah data");
        this.getData();
      })
    },

    removeData : function(id){
      fetch(ADD_URL+"remove", {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token,
        },
        body : JSON.stringify({
          id : id,
        })
      }).then(()=>{
        this.alertku("success", "sukses menghapus data");
        this.getData();
      })
    },

    getView : function(kecamatan_id,kecamatan,type,status, sekolah, alamat, id){
      this.kecamatan_id = kecamatan_id;
      this.kecamatan = kecamatan;
      this.type = type;
      this.status = status;
      this.sekolah = sekolah;
      this.alamat = alamat;
      this.id = id;
    },



// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================

// ================== AUTOCOMPLETED ====================
    autocompleted : function(){

      $.ajax({
        url: URL_APP+'api/v1/kecamatan/',
        type: "GET",
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token,
        },
        success: function(result){

          horsey(document.querySelector('#kecamatan'), {
            source: [{ list: result }],
            getText: 'kecamatan',
            getValue: 'kecamatan',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="body_auto">`+suggestion.kecamatan+`</span>
              <span class="head_auto">(`+suggestion.detilkabupaten.kabupaten+`)</span><br>`
            },
            predictNextSearch(info) {
              document.getElementById('kecamatan_id').value= info.selection.id ;
            },
            limit: 2
          });

          horsey(document.querySelector('#e_kecamatan'), {
            source: [{ list: result }],
            getText: 'kecamatan',
            getValue: 'kecamatan',
            renderItem: function (li, suggestion) {
              li.innerHTML = `<span class="body_auto">`+suggestion.kecamatan+`</span>
              <span class="head_auto">(`+suggestion.detilkabupaten.kabupaten+`)</span><br>`
            },
            predictNextSearch(info) {
              document.getElementById('e_kecamatan_id').value= info.selection.id ;
            },
            limit: 2
          });

      }});

    },
// ================== AUTOCOMPLETED ====================

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
    this.autocompleted();
  },
};
</script>
